<template>
    <div class="w-100">
        <div class="row">
            <div class="col-4 pr-1">
                <BaseSelect
                    v-model="day"
                    :placeholder="$t('core.day')"
                    :clearable="!required">
                    <BaseOption
                        v-for="dayOption in daysOfMonth"
                        :key="'dayOption' + dayOption"
                        :label="dayOption"
                        :value="dayOption" />
                </BaseSelect>
            </div>
            <div class="col-4 px-1">
                <BaseSelect
                    v-model="month"
                    :placeholder="$t('core.month')"
                    :clearable="!required">
                    <BaseOption
                        v-for="monthOption in months"
                        :key="'monthOption' + monthOption"
                        :label="monthOption"
                        :value="monthOption" />
                </BaseSelect>
            </div>
            <div class="col-4 pl-1">
                <BaseSelect
                    v-model="year"
                    :placeholder="$t('core.year')"
                    :clearable="!required">
                    <BaseOption
                        v-for="yearOption in availableYears"
                        :key="'yearOption' + yearOption"
                        :label="yearOption"
                        :value="yearOption" />
                </BaseSelect>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BaseDateSelectInput",
    inheritAttrs: false,
    props: {
        modelValue: {
            type: String,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        rules: {
            type: [String, Array, Object],
            description: 'Vee validate validation rules',
            default: ''
        },
        name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            day: null,
            month: null,
            year: null
        }
    },
    computed: {
        daysOfMonth() {
            return Array.from({length: 31}, (v, k) => k + 1);
        },
        availableYears() {
            const maxYear = this.$moment().year() + 1;
            return Array.from({length: 150}, (v, k) => maxYear - k);
        },
        dateIsInvalid() {
            if (!(this.day && this.month && this.year)) return false;
            const date = this.$moment({
                day: this.day,
                month: this.month - 1,
                year: this.year
            });
            return !date.isValid();
        },
        validDate() {
            if (!(this.day && this.month && this.year)) return null;
            const date = this.$moment({
                day: this.day,
                month: this.month - 1,
                year: this.year
            });

            if (!date.isValid()) return null;
            return date.format('YYYY-MM-DD')
        },
        dateValidationRules() {
            if (this.dateIsInvalid) return {dateIsInvalid: true}
            return this.rules
        },
        dateToValidate() {
            if (this.dateIsInvalid) return this.$moment().format('YYYY-MM-DD')
            return this.modelValue
        }
    },
    watch: {
        validDate: {
            handler(val) {
                this.$emit('update:modelValue', val)
            }
        },
        modelValue: {
            handler(val) {
                if (!val) return;
                const date = this.$moment(val);
                if (!date.isValid()) return;
                this.day = date.date();
                this.month = date.month() + 1;
                this.year = date.year();
            },
            immediate: true
        }
    }

};
</script>
<style>

</style>
